export default __webpack_public_path__ + "static/media/tg.1b41a405.svg";